<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="view()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  import Change from '../bi/change'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      view () {
        let propsData = {
          context: this,
          new_service_id: parseInt(this.data.newserviceid),
          old_service_id: parseInt(this.data.serviceid),
          charge: parseInt(this.data.charge),
          change_id: parseInt(this.data.id),
          callback: 'openChangeCheck'
        }
        Change.openChangeCheck(propsData)
      },
      openChangeCheck () {
        this.$parent.loadData()
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ChangeTableButtons.vue?53811260